import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconProfilePencil: React.FC<IconProps> = ({ width = 20, height = 20, color = '#23262A' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 15 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.7175 1.63281C5.92469 1.63281 3.50781 5.06886 3.50781 7.93482C3.50781 9.66978 4.16468 11.2132 5.57332 11.7879C5.80439 11.8831 6.01147 11.7914 6.0785 11.5356C6.12507 11.3592 6.23549 10.9126 6.28452 10.726C6.3519 10.4731 6.3258 10.3849 6.13918 10.1637C5.73313 9.68495 5.47313 9.06477 5.47313 8.18565C5.47313 5.63648 7.3806 3.35437 10.4399 3.35437C13.1489 3.35437 14.6372 5.0096 14.6372 7.21975C14.6372 10.1287 13.3499 12.5837 11.4393 12.5837C10.3838 12.5837 9.59428 11.7113 9.84687 10.6406C10.1499 9.36251 10.7373 7.98386 10.7373 7.06064C10.7373 6.23514 10.2938 5.54652 9.37697 5.54652C8.29817 5.54652 7.4314 6.66271 7.4314 8.15743C7.4314 9.10957 7.75313 9.75374 7.75313 9.75374C7.75313 9.75374 6.64929 14.4316 6.45562 15.2507C6.07039 16.8823 6.39776 18.8819 6.42563 19.0836C6.44186 19.2036 6.59567 19.2325 6.66552 19.1422C6.76465 19.012 8.05017 17.4259 8.48656 15.8406C8.61038 15.3922 9.19599 13.0681 9.19599 13.0681C9.54665 13.737 10.5711 14.3247 11.6605 14.3247C14.9029 14.3247 17.1031 11.3688 17.1031 7.41201C17.1035 4.4194 14.5691 1.63281 10.7175 1.63281Z"
                fill={color}
            />
        </svg>
    );
};

export default IconProfilePencil;
